<template>
  <el-dialog
    :visible="visible"
    v-if="visible"
    v-el-dialog-drag
    show-close
    width="800px"
    :title="
      order.bizStatus === '4' || order.bizStatus === '6'
        ? '修改POD回单'
        : '上传POD回单'
    "
    top="10vh"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <PodIndex
      @close="close()"
      @reload="$emit('reload')"
      ref="podIndex"
      :order="order"
    />
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary" @click="() => $refs.podIndex.save()">
        确认上传
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import PodIndex from './index.vue'
export default {
  components: { PodIndex },
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
